var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"svg-content",attrs:{"d":"M1 4L4 7L9 1","stroke":"white","stroke-width":"2","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }